import React, {useState, useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Grid, Button, Alert } from "@deere/fuel-react";
import TableCard from '../../components/details/Table.card'
import PercentageCard from '../../components/details/Percentage.card'
import SurveyInfoCard from '../../components/details/SurveyInfo.card'
import { ReactComponent as ExcelIcon } from "@deere/ux.brand-foundations/icons/excel.svg";
import { closeCampaign } from '../../services/campaign.service';
import { useOktaAuth } from '@okta/okta-react'
import { getCampaignResponses } from '../../services/campaign.service';
import { SCBM_STATES_CAMPAIGN, CLOSING_ALERT, CRS_SURVEY_CODES, CRS_SURVEY_TEMPLATES } from '../../utils/surveyLiterals'
import { useUserInfo } from '../../providers/userProvider'
import { isUserACRSAdmin, isUserAnAdminOfSurvey } from '../../utils/utils'
import { excelExport } from '../../utils/downloadUtils'
import { CircularIndicator } from '../../components/CircularIndicator'
import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add_circle.svg";
import ModalAddSupplier from "../../components/details/ModalAddSupplier";
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router';
import { templateData } from '../../services/external.service';

export default function DetailsPage() {
    const location = useLocation();
    const { authState } = useOktaAuth();
    const [downloadingFile, setDownloading] = useState(false)
    const [closed, setClosed] = useState(false)
    const [successClosed, setSuccessClosed] = useState(false)
    const [errorClosed, setErrorClosed] = useState(false)
    const [campaignResponses, setCampaignResponses] = useState([])
    const [loading, setLoading] = useState(true);
    const [showAddSupplierModal, setShowAddSupplierModal] = useState(false);
    const userInfo = useUserInfo();
    const { t } = useTranslation();
    const history = useHistory();
    const defaultValue = location.state === undefined ? {} : location.state.campaign;
    const [additionalColumns, setAdditionalColumns] = useState([]);

    const [campaign, setCampaign] = useState(() => {
        const stored = localStorage.getItem(`campaign${defaultValue.id}`)
        if (stored !== null) {
            const json = JSON.parse(stored)
            return json
        }
        return defaultValue
    })

    useEffect(() => {
        loadCampaing()
    }, [authState.accessToken.accessToken, campaign])

    useEffect(() => {
        return () => {
            localStorage.removeItem(`campaign${defaultValue.id}`)
        };
    }, []);

    useEffect(() => {
        if (campaign && campaign.surveyId) {
            templateData(authState.accessToken.accessToken, campaign.surveyId).then(data => {
                if (data) {
                    setAdditionalColumns(data);
                }
            }).catch(err => { console.log(err) })
        }
    }, [campaign])

   
   const loadCampaing= () =>{
        if (campaign !== null && campaign !== undefined && campaign) {
            setLoading(true) 
            getCampaignResponses(campaign, authState.accessToken.accessToken).then((response) => {
            setCampaignResponses(response)
            setLoading(false);
             }
            ).catch(err => { 
                console.log(err)
                setLoading(false)
            });
        }
   }


    if (campaign === null || campaign === undefined || !campaign.hasOwnProperty('id')) {
        return <div>
            <Link to='/'>Search Campaigns</Link>
            <h2 className='m-2'>{`Campaign Details`}</h2>
            <Grid container mt={4}>
                <Grid item xs={12}>
                    <Alert accessibilityLabel="Info:" variant="info" aria-atomic="true">
                        <h5 className="uxf-alert-title">{'Campaign Info'}</h5>
                        <p className="uxf-alert-description">
                            {'No Campaign Info Available'}
                        </p>
                    </Alert>
                </Grid>
            </Grid>
        </div>
    }

    const handleExcelDownload = e => {
        try {
            setDownloading(true)
            const detailsTables = document.getElementsByClassName("table");
            excelExport(detailsTables[0], campaign, campaignResponses, userInfo.roles);
            setDownloading(false)
        }
        catch (err) {
            setDownloading(false)
            throw err
        }
    }

    const handleCloseCampaign = e => {
        try {
            if (!window.confirm(CLOSING_ALERT))
                return;
            setClosed(true)

            if (campaign.notificationConfig) {
                const fromEmail = campaign.notificationConfig.fromEmail === null ? "" : campaign.notificationConfig.fromEmail;
                campaign.notificationConfig.fromEmail = fromEmail;
            }
            const campaignToClose = { 
                ...campaign,
                status: SCBM_STATES_CAMPAIGN.CLOSED,
                updatedBy: userInfo.userID,
                isNonDeere: !campaign.isNonDeere? false : campaign.isNonDeere,
                companyName: !campaign.companyName? '' : campaign.companyName,
            }
            closeCampaign(authState.accessToken.accessToken, campaignToClose).then(response => {
                localStorage.setItem(`campaign${campaignToClose.id}`, JSON.stringify(campaignToClose))
                setCampaign(JSON.parse(localStorage.getItem(`campaign${campaignToClose.id}`)));
                setSuccessClosed(true)
                setClosed(false)
                setErrorClosed(false)
            }).catch(err => {
                console.log(err)
                setErrorClosed(true)
                setClosed(false)
                setSuccessClosed(false)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    const loadingExcelButton = <Button variant="outline-success" disabled>
        <ExcelIcon size='sm' />
        <span className="visually-hidden ml-2">Loading...</span>
    </Button>

    const loadingCloseCampaignButton = <Button variant="outline-success" disabled className='ml-2'>
        <span className="visually-hidden">Closing...</span>
    </Button>

    const downloadExcelButton = <Button variant="outlined" color="success" className='ml-2' onClick={handleExcelDownload}> <ExcelIcon size='sm' /> {'Download'} </Button>
    const closedCampaignButton = <Button variant="secondary" className='ml-2' onClick={handleCloseCampaign}>{'Close Campaign'}</Button>
    const successAlert = <Alert accessibilityLabel="Success:" variant="success" aria-atomic="true">
        <h5 className="uxf-alert-title">{'Campaign Close'}</h5>
        <p className="uxf-alert-description">
            {'Campaign was successfully closed'}
        </p>
    </Alert>
    const errorAlert = <Alert accessibilityLabel="Danger:" variant="danger" aria-atomic="true">
        <h5 className="uxf-alert-title">{'Campaign Close'}</h5>
        <p className="uxf-alert-description">
            {'Something happended during campaign close action'}
        </p>
    </Alert>


    const excelButton = () => {
        if (downloadingFile)
            return loadingExcelButton
        return downloadExcelButton
    }

    const closeCampaignButton = () => {
        if (!isUserAnAdminOfSurvey(userInfo.roles, campaign.adminRole))
            return null
        else {
            if (campaign.hasOwnProperty('status')) {
                if (closed)
                    return loadingCloseCampaignButton
                if (campaign.status.trim().toLowerCase() !== SCBM_STATES_CAMPAIGN.CLOSED.trim().toLowerCase())
                    return closedCampaignButton
                return null
            }
        }

    }

    const addSupplierButton = () => {
        let showButton = true;
        if(campaign.surveyCode === CRS_SURVEY_CODES.CM ||campaign.surveyCode === CRS_SURVEY_CODES.EM || campaign.surveyCode === CRS_SURVEY_CODES.TPS || campaign.surveyCode === CRS_SURVEY_CODES.TPSMEX || campaign.surveyCode === CRS_SURVEY_CODES.COO) showButton = false; //Button not avaliable for these surveys
        else if(!userInfo.roles.includes(campaign.adminRole))   showButton = false; // Button only available for admin roles
        else if(campaign.status === SCBM_STATES_CAMPAIGN.CLOSED)    showButton = false; // Button not available if campaign is closed.
        if(showButton)  return <Button variant="secondary" className='ml-2' onClick={()=>{setShowAddSupplierModal(true)}}><AddIcon /> Add Supplier</Button>
        else return null
    }

    const showAlert = () => {
        if (successClosed)
            return successAlert
        else if (errorClosed)
        { window.scrollTo(0,0);
            return errorAlert
        }
        return null
    }

    const reloadAfterSupplierAdd = () => {
        campaign.noAssignments = campaign.noAssignments + 1;
        history.push({
            pathname: '/details',
            state: { campaign: campaign, previous: '/' }
        });
        window.location.reload(false);
    }

    return (
        <div>
            <Link to='/'>Search Campaigns</Link>
            <h2 className='m-2'>{`#${campaign.id} ${campaign.surveyType}`}</h2>
            {showAlert()}
            <Grid container spacing={5} mt={3}>
                <Grid item xs={6}>
                    <SurveyInfoCard campaign={campaign} campaignRes={campaignResponses} />
                </Grid>
                <Grid item xs={6}>
                    <PercentageCard campaign={campaign} />
                </Grid>
                <Grid item xs={12}>
                    {loading ? (
                        <CircularIndicator message={"Retrieving Campaign Responses"} details={"This will take a minute"} />
                    ) : (
                        <TableCard campaignRes={campaignResponses} campaign={campaign} accessToken={authState.accessToken.accessToken} loadCampaing={loadCampaing} additionalColumns={additionalColumns}/>
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="flex-end">
                            {excelButton()}
                            {addSupplierButton()}
                            {closeCampaignButton()}
                    </Grid>
                </Grid>
            </Grid>
            <ModalAddSupplier
                    showModal={showAddSupplierModal} 
                    setShowModal={setShowAddSupplierModal}
                    labelBtnPrimary={campaign.templateType === CRS_SURVEY_TEMPLATES.PART ? t("btn_next") : t("btn_save_survey")}
                    labelBtnSecondary={t("btn_cancel")}
                    titleModal={t("lbl_add_supplier")}
                    reload={reloadAfterSupplierAdd}
                    campaignId={campaign.id}
                    campaignResponses={campaignResponses}
                    isNonDeere={campaign.isNonDeere}
                    proceedToAddParts={campaign.templateType === CRS_SURVEY_TEMPLATES.PART ? true : false}
                />
        </div>
    )

}